<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <div>
      <p class="md:text-2xl text-center -mt-10 text-root-2 font-bold mb-3">
        Deposit Details
      </p>
      <p class="text-13px font-normal text-fg-muted text-center">
        {{
          isWireTransferInternational
            ? 'Wire transfer International'
            : isWireTransferUS
            ? 'Wire transfer  United States'
            : isPoundsDeposit
            ? 'Bank Deposit'
            : 'Local Currency Deposit'
        }}
      </p>
    </div>
    <div>
      <local-currency-deposit
        v-if="isLocalDepositInfo"
        @handleClose="handleClose"
      />
      <bank-deposit-details v-if="isPoundsDeposit" @handleClose="handleClose" />
      <wire-transfer-information
        v-if="isWireDeposit"
        @handleClose="handleClose"
      />
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints,
      activeView: 'deposit'
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose')
    }
  },
  components: {
    LocalCurrencyDeposit: () =>
      import(
        '@/components/v2/deposit/dialogs/depositDetailsDialog/LocalCurrencyDeposit.vue'
      ),
    WireTransferInformation: () =>
      import(
        '@/components/v2/deposit/dialogs/depositDetailsDialog/WireTransferInformation.vue'
      ),
    BankDepositDetails: () =>
      import(
        '@/components/v2/deposit/dialogs/depositDetailsDialog/BankDepositDetails.vue'
      )
  },
  computed: {
    isWireDeposit () {
      return this.isWireTransferInternational || this.isWireTransferUS
    },
    isLocalDepositInfo () {
      return (
        this.$store.state.transactions.depositDetailsType === 'localTransfer'
      )
    },
    isWireTransferInternational () {
      return (
        this.$store.state.transactions.depositDetailsType ===
        'wireTransferInternational'
      )
    },
    isWireTransferUS () {
      return (
        this.$store.state.transactions.depositDetailsType === 'wireTransferUS'
      )
    },
    isPoundsDeposit () {
      return (
        this.$store.state.transactions.depositDetailsType ===
        'GBPDepositDetails'
      )
    },
    isSwapView () {
      return this.activeView === 'swap'
    },
    modalWidth () {
      return breakpoints.lgAndUp ? '27rem' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 16px;
  padding: 5px;
  background-color: white;
}
>>> .el-dialog__close .el-icon .el-icon-close {
  color: black !important;
}
</style>
